// Builds the final title sent to POST /tickets/details.
export const buildSubmitTitle = (titlePrefix, title) => {
  const trimmedTitle = (title ?? '').trim();
  const trimmedPrefix = (titlePrefix ?? '').trim();

  if (!trimmedPrefix) {
    return trimmedTitle;
  }

  if (trimmedTitle.toLowerCase().startsWith(trimmedPrefix.toLowerCase())) {
    return trimmedTitle;
  }

  return `${trimmedPrefix} ${trimmedTitle}`;
};

// Max chars the user may type so buildSubmitTitle(...) stays within apiMaxLength.
export const getTitleUserMaxLength = (apiMaxLength, titlePrefix) => {
  if (apiMaxLength == null) {
    return undefined;
  }

  const prefix = (titlePrefix ?? '').trim();
  if (!prefix) {
    return apiMaxLength;
  }

  const separatorLength = 1;

  return Math.max(0, apiMaxLength - prefix.length - separatorLength);
};
